module.exports = __webpack_public_path__ + "img/meeting-date.35230f69.svg";